import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteBrandAction } from '../../../redux/actions/brandsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';

const DeleteBrandModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const brand = useSelector((state) => state.brands?.brand);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deleteBrandAction(brand.id));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Видалення марки'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити цю марку?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeleteBrandModal;
